import { Component, OnInit } from '@angular/core';
import { baseConfig } from '../../config/config.base';

@Component({
    selector: 'mesc-user-profile',
    templateUrl: './user-profile.component.html',
    // styleUrls: ['./users.component.scss']
})

export class UserProfileComponent {
    moduleGroups: any[] = [];
    moduleName: string;
    groupDisplayName: string;

    setContent(data: any[]) {
        var self = this;
        self.moduleGroups = [];
        try {
            for (var i = 0; i < data["ModuleClaims"].length; i++) {
                for (var prop in baseConfig.modules.Modules[0]) {
                    self.moduleName = "";
                    if (data["ModuleClaims"][i] === prop.toString()) {
                        self.moduleName = data["ModuleClaims"][i];
                        var moduleGroup = {
                            moduleName: self.moduleName,
                            groupNames: []
                        }
                        for (var j = 0; j < baseConfig.modules.Modules[0][prop].length; j++) {
                            self.groupDisplayName = "";
                            if (data["GroupClaims"].includes(baseConfig.modules.Modules[0][prop][j]["GroupName"])) {
                                self.groupDisplayName = baseConfig.modules.Modules[0][prop][j]["DisplayName"];
                            }
                            if (self.moduleName !== "" && self.groupDisplayName !== "") {
                                moduleGroup.groupNames.push(self.groupDisplayName);
                            }
                        }
                        self.moduleGroups.push(moduleGroup);
                    }
                }
            }
            if (data["GroupClaims"].includes(baseConfig.modules.Modules[0]["MESC"][0]["GroupName"])) {
                self.moduleGroups.push({
                    moduleName: "MESC",
                    groupNames: [baseConfig.modules.Modules[0]["MESC"][0]["DisplayName"]]
                })
            }
        } catch (e) {
            console.error("UserProfileException - ", e.status, e.message);
        }
    }
}